import MainPresenter from './main/presenters/MainPresenter.js';

document.addEventListener('DOMContentLoaded', () => {
  MainPresenter.init();
});
